import { ActionReducer } from "@ngrx/store";
import { QuoteState } from "src/app/store/pages/quote/quote.state";
import { PagesStore } from "src/app/store/pages/pages.state";
import { PdfState } from "./pdf.state";

interface AppStateWithStores {
    pages?: PagesStore;
    pdf?: PdfState;
    [key: string]: unknown;
}

/**
 * Synkar quote state till PDF state efter varje action.
 * Synkar alltid om quote data finns - ingen aktivering behövs.
 *
 * UNDANTAG: Om fetchesCurrencyConvertedQuote är true skippas sync.
 * Detta används när versionens valuta !== företagets basvaluta,
 * då hämtas konverterad data från API istället.
 */
export function quoteStoreSyncMetaReducer(
    reducer: ActionReducer<AppStateWithStores>
): ActionReducer<AppStateWithStores> {
    return (state, action) => {
        const nextState = reducer(state, action);
        const pdf = nextState?.pdf;
        const quote = nextState?.pages?.quote;

        // Skippa sync om PDF använder konverterad valutadata från API
        if (pdf?.fetchesCurrencyConvertedQuote) {
            return nextState;
        }

        // Synka om quote data finns
        if (!quote?.versions?.length) {
            return nextState;
        }

        // Hitta vald version
        const version = quote.versions.find(v => v.id === quote.selectedVersion);
        if (!version) {
            return nextState;
        }

        // Kopiera quote med endast vald version
        return {
            ...nextState,
            pdf: {
                ...pdf,
                quote: {
                    ...quote,
                    versions: [version],
                },
            },
        };
    };
}
